/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemIdentifierRecordModel } from '../../models/system-identifier-record-model';

export interface SystemIdentifierIdGet$Params {
  id: string;
}

export function systemIdentifierIdGet(http: HttpClient, rootUrl: string, params: SystemIdentifierIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<SystemIdentifierRecordModel>> {
  const rb = new RequestBuilder(rootUrl, systemIdentifierIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<SystemIdentifierRecordModel>;
    })
  );
}

systemIdentifierIdGet.PATH = '/SystemIdentifier/{id}';
